import React from 'react';
import { useDispatch } from 'react-redux';
import { SettingsActions } from '../../../redux/Settings';
import difficulties from '../../../data/difficulty';
import BaseSelector from '../../baseSelector';

const difficultySelector = () => {
  const dispatch = useDispatch();

  const handleDifficultyChange = (data) => {
    dispatch(SettingsActions.setDifficulty(data.target.value));
  };

  const options = [
    { name: 'Normal', value: difficulties.easy },
    { name: 'Nightmare', value: difficulties.normal },
    { name: 'Hell', value: difficulties.hard },
    { name: 'Inferno', value: difficulties.nightmare },
  ];

  return (
    <BaseSelector
      options={options}
      label="Difficulty"
      id="difficultySelector"
      onChange={handleDifficultyChange}
    />
  );
};

export default difficultySelector;
